// extracted by css-extract-rspack-plugin
export default {"headerIcon":"Dr__vBlvJ202mOdN","graphContainer":"xmPqicy9jVs5F0me"};